import React from 'react';
import graphql from 'graphql';
import Helmet from 'react-helmet';
import Head from '../../components/Head';
import ContactForm from '../../components/contact';

const TechnologyDjangoPage = ({ data }) => (
  <div>
    <Helmet title={`Django | ${data.site.siteMetadata.title}`} />

    <div className="hero is-relative is-theme-secondary hero-waves">
      <Head />
      <div id="main-hero" className="hero-body ">
        <div className="container">
          <div className="columns is-vcentered is-tablet-portrait">
            <div className="column is-5 header-caption has-text-left">
              <h1 className="landing-title">Django Development</h1>
              <h2 className="subtitle is-5 light-text">
                We have more than 10 years of experience developing Django web for business, higher education, and social good, impacting millions of people
                worldwide.{' '}
              </h2>
              <p className="pt-10 pb-10">
                <a href="#contact-form" className="button button-cta btn-align btn-outlined is-bold light-btn rounded z-index-2">
                  Let&apos;s build together
                </a>
              </p>
            </div>

            <div className="column is-9 is-offset-1">
              <figure className="image is-4by4 django-logo">
                <img
                  className="hero-angular-logo"
                  src="/files/images/logos/main/django-logo.png"
                  // height="80%" width="60%"
                  alt="logo"
                />
              </figure>
            </div>
          </div>
        </div>
      </div>
    </div>

    <section id="features" className="section is-medium">
      <div className="container has-text-centered">
        <div className="section-title-wrapper has-text-centered">
          <div className="bg-number">1</div>
          <h2 className="section-title-landing">Why we choose Django? Always.</h2>
          <h4>Django is a very mature framework and is used by many big companies. It allows us develop and run a fully functioning web app quickly.</h4>
        </div>
        <div className="content-wrapper">
          <div className="columns is-vcentered has-text-centered">
            <div className="column is-hidden-mobile" />
            <div className="column is-3">
              <div className="square-icon-box is-landing secondary">
                <div className="icon-box-wrapper">
                  <div className="icon-box">
                    <i className="fas fa-smile" />
                  </div>
                </div>
                <div className="box-title">Fully loaded </div>
                <div className="box-text is-tablet-padded">
                  Django includes dozens of extras you can use to handle common Web development tasks like Authentication, administration and many more.
                </div>
              </div>
            </div>
            <div className="column is-3">
              <div className="square-icon-box is-landing secondary">
                <div className="icon-box-wrapper">
                  <div className="icon-box">
                    <i className="fas fa-mobile-alt" />
                  </div>
                </div>
                <div className="box-title">Fast</div>
                <div className="box-text is-tablet-padded">
                  From idea, production to release, Django helps in making it both cost effective and efficient. It helps the developer to make an application
                  as fast as possible.
                </div>
              </div>
            </div>
            <div className="column is-3">
              <div className="square-icon-box is-landing primary">
                <div className="icon-box-wrapper">
                  <div className="icon-box">
                    <i className="fas fa-tasks" />
                  </div>
                </div>
                <div className="box-title"> Secure </div>
                <div className="box-text is-tablet-padded">
                  When you are doing it in Django, it is ensured that developers do not commit any mistakes related to security.
                </div>
              </div>
            </div>
            <div className="column is-3">
              <div className="square-icon-box is-landing primary">
                <div className="icon-box-wrapper">
                  <div className="icon-box">
                    <i className="fab fa-github" />
                  </div>
                </div>
                <div className="box-title">Versatile</div>
                <div className="box-text is-tablet-padded">
                  Aspects like content management, scientific computing platforms, and even big organizations are efficiently managed by the use of Django.{' '}
                </div>
              </div>
            </div>
            <div className="column is-hidden-mobile" />
          </div>
        </div>
      </div>
    </section>

    <section id="services" className="section section-feature-grey is-medium">
      <div className="container">
        <div className="section-title-wrapper has-text-centered">
          <div className="bg-number">?</div>
          <h2 className="section-title-landing">What Next offers</h2>
        </div>
        <div className="content-wrapper">
          <div className="columns is-vcentered">
            <div className="column is-4">
              <div className="content content-flex">
                <div className="dark-text">
                  <i className="fas fa-chart-line is-size-2 color-primary" />
                </div>
                <div className="dark-text has-text-left ml-30">
                  <h5 className="is-landing primary-text text-bold pt-5 pb-5">Boost Productivity</h5>
                  Our team has perfect Django skills-set you&apos;re looking for. We can easily help your team with minimal time to increase your productivity
                  so that you can meet your project deadlines which you strive for.
                </div>
              </div>
            </div>
            <div className="column is-4">
              <div className="content content-flex">
                <div className="dark-text">
                  <i className="fas fa-hands-helping is-size-2 color-primary" />
                </div>
                <div className="dark-text has-text-left ml-30">
                  <h5 className="is-landing primary-text text-bold pt-5 pb-5">Steer your Project</h5>
                  It doesn&apos;t matter whether you&apos;re stuck on a technical issue or facing an unexpected development difficulty, our team can help to
                  steer your project back on track by providing solutions for the issues and difficulties with minimum impact on your deadline.
                </div>
              </div>
            </div>
            <div className="column is-4">
              <div className="content content-flex">
                <div className="dark-text">
                  <i className="fas fa-user-tie is-size-2 color-primary" />
                </div>
                <div className="dark-text has-text-left ml-30">
                  <h5 className="is-landing primary-text text-bold pt-5 pb-5">Django Experience</h5>
                  As we have experience of working with small and big projects, our team can help you with project architecture and strategy as well as provide
                  guidance and solutions on technical issues.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <ContactForm />
  </div>
);

export default TechnologyDjangoPage;

export const TechnologyDjangoPageQuery = graphql`
  query TechnologyDjangoPageQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/technologies/django.jsx